import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import RedirectMessage from './RedirectMessage';

export const PublicRoute = ({ children }) => {
  const { user } = useAuth();

  if (user) {
    return (
      <>
        <RedirectMessage 
          message="Sei già autenticato. Reindirizzamento alla dashboard..." 
          onClose={() => {}} 
        />
        <Navigate to="/dashboard" />
      </>
    );
  }

  return children;
};